<script setup lang="ts">
import { RouterView } from 'vue-router';
// Bootstrap the locale store as early as possible — its setup() applies the
// detected locale to vue-i18n + <html lang> before any view renders. Without
// this call the store would only initialize on first useLocaleStore() inside
// some other component, leading to a brief flash in the fallback locale on
// hard refresh.
import { useLocaleStore } from '@/stores/locale';
import DemoModal from '@/components/demo/DemoModal.vue';
useLocaleStore();
</script>

<template>
  <RouterView />
  <!-- Mounted at root so the modal listens for vc:demo-readonly across all
       views (auth, dashboard, etc.) without per-view boilerplate. -->
  <DemoModal />
</template>
